export enum VehicleDriverRegenerateCodeStatusType {
  UN_SUCCESS = 'UnSuccess',
  SUCCESS = 'Success',
}
